import { render, staticRenderFns } from "./createCouponForm.vue?vue&type=template&id=71bcce00&scoped=true&"
import script from "./createCouponForm.vue?vue&type=script&lang=js&"
export * from "./createCouponForm.vue?vue&type=script&lang=js&"
import style0 from "./createCouponForm.vue?vue&type=style&index=0&id=71bcce00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bcce00",
  null
  
)

export default component.exports